<template>
  <div class="nav-wrapper">
    <nav
      :class="[
        'nav',
        navType === 'normal' && 'nav--normal',
        navType === 'home' && 'nav--home'
      ]"
    >
      <button class="nav__btn btn--main" type="button" @click="toggleShow">
        <svg class="nav__icon" viewBox="0 0 512 512">
          <path
            d="M-0.97 318.93l513.94 0 0 54.09 -513.94 0 0 -54.09zm0 -179.95l513.94 0 0 54.09 -513.94 0 0 -54.09z"
          />
        </svg>
      </button>

      <h1 class="nav__msg" v-if="msg">{{ msg }}</h1>

      <template v-if="navType === 'home'" class="navbar-brand">
        <img class="nav__logo" src="@img/vipon-logo.svg" />
      </template>
      <button
        class="nav__btn btn--back"
        type="button"
        v-else
        @click.prevent="goBack"
        @dblclick="() => {}"
      >
        <svg viewBox="0 0 512 512">
          <path
            d="M174.6 252.89l205.16 -205.16c7.2,-7.21 7.2,-18.89 0,-26.1 -7.2,-7.2 -18.88,-7.2 -26.09,0l-221.43 221.44c-7.2,7.2 -7.2,18.88 0,26.09l221.43 221.43c7.33,7.08 19.01,6.87 26.09,-0.46 6.91,-7.15 6.91,-18.48 0,-25.63l-205.13 -205.13 0 -0.03c-0.82,-0.83 -1.33,-1.97 -1.33,-3.23 0,-1.26 0.51,-2.4 1.33,-3.22l-0.03 0z"
          />
        </svg>
      </button>
    </nav>
    <div class="collapse" :class="[show && 'collapse--show']">
      <div class="collapse__inside">
        <div class="collapse__logo">
          <img src="@img/vipon-logo-black.svg" />
        </div>
        <div class="cmp-items-wrapper">
          <router-link class="remain" :to="{ name: 'TransactionPackage' }">
            <i class="remain__animate" />
            <span class="remain__text">اشتراک</span>
            <h3 class="remain__day">
              {{ expDay }}
            </h3>
            <span class="remain__left">روز مانده</span>
          </router-link>
          <!-- <div class="nav__btn btn--package">
            افزایش اشتراک
            <svg viewBox="0 0 512 512">
              <path
                d="m368 272h-224c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h224c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"
              />
              <path
                d="m256 384c-8.832031 0-16-7.167969-16-16v-224c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v224c0 8.832031-7.167969 16-16 16zm0 0"
              />
            </svg>
          </div> -->
          <a
            class="money"
            @click="$store.dispatch('profile/handlePayModal', 'open')"
          >
            <span class="money__title">موجودی</span>
            <div v-if="credit || credit === 0" class="money__row">
              <svg
                style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd; height: 30px"
                viewBox="0 0 512 512"
                class="money__add"
              >
                <path
                  d="M256 0c141.39,0 256,114.61 256,256 0,141.39 -114.61,256 -256,256 -141.39,0 -256,-114.61 -256,-256 0,-141.39 114.61,-256 256,-256zm-13.13 380.37l0 -111.24 -111.24 0c-7.22,0 -13.13,-5.91 -13.13,-13.13l0 0c0,-7.22 5.91,-13.13 13.13,-13.13l111.24 0 0 -111.24c0,-7.22 5.91,-13.13 13.13,-13.13l0 0c7.23,0 13.14,5.91 13.14,13.13l0 111.24 111.23 0c7.22,0 13.13,5.91 13.13,13.13l0 0c0,7.22 -5.91,13.13 -13.13,13.13l-111.23 0 0 111.24c0,7.22 -5.92,13.13 -13.14,13.13l0 0c-7.22,0 -13.13,-5.91 -13.13,-13.13zm13.13 -354.99c127.37,0 230.62,103.25 230.62,230.62 0,127.37 -103.25,230.62 -230.62,230.62 -127.37,0 -230.62,-103.25 -230.62,-230.62 0,-127.37 103.25,-230.62 230.62,-230.62z"
                />
              </svg>
              <p class="money__price">{{ credit.toLocaleString() }}</p>
            </div>
            <div class="line" v-else />
          </a>
        </div>
        <ul class="collapse__items">
          <router-link class="nav__item" :to="{ name: 'ProfileEdit' }">
            <svg viewBox="0 0 700 512" class="nav__itemLogo">
              <path
                d="M57.73 111.01l-0.04 0.09c-0.11,0.23 -0.22,0.46 -0.31,0.68l-0.02 0.04c-0.02,0.07 -0.04,0.13 -0.06,0.18 -0.17,0.46 -0.32,0.93 -0.45,1.4 -0.04,0.17 -0.08,0.33 -0.13,0.55 -0.05,0.17 -0.07,0.35 -0.1,0.49 -0.04,0.21 -0.07,0.43 -0.1,0.69 -0.02,0.14 -0.04,0.29 -0.05,0.48 -0.04,0.37 -0.02,0.75 -0.03,1.09 0,0.07 0.02,0.15 0.03,0.21l0.02 0.08 0 52.32c0,21.07 17.07,38.69 38.26,38.69l3.03 0 0 290.75c-0.19,7.12 5.53,13.06 12.69,13.24 0.08,0.01 0.16,0.01 0.24,0.01l477.93 0c7.39,0 13.47,-5.85 13.63,-13.24l0 -290.76 3.03 0c21.19,0 38.25,-17.62 38.25,-38.69l0 -52.59c0.02,-0.51 -0.01,-1.03 -0.07,-1.57l-0.01 -0.08c0,-0.06 0,-0.14 -0.02,-0.27 -0.06,-0.47 -0.15,-0.93 -0.26,-1.34 -0.03,-0.11 -0.04,-0.2 -0.06,-0.28 -0.31,-1.08 -0.72,-2.08 -1.27,-3.03 -0.04,-0.05 -0.05,-0.09 -0.08,-0.14l-53.87 -91.19c-6.89,-11.66 -19.45,-18.82 -33,-18.82l-399.89 0c-12.52,0 -24.27,6.11 -31.43,16.37l-64.73 92.74c-0.18,0.26 -0.34,0.49 -0.48,0.72 -0.04,0.07 -0.07,0.11 -0.12,0.21l-0.03 0.05c-0.14,0.24 -0.28,0.48 -0.4,0.72 -0.04,0.08 -0.07,0.14 -0.1,0.2zm37.52 -7.18l50.16 -72.04c2.21,-3.16 5.77,-5.11 9.65,-5.18l399.88 0c4.15,0.07 7.95,2.36 10.05,5.93l42.01 71.29 -511.75 0zm311.52 381.55l-113.5 0 0 -168.54 113.5 0 0 168.54zm168.88 0l-142.26 0 0 -181.69c-0.22,-7.47 -6.26,-13.46 -13.76,-13.46l-139.89 0c-7.3,0.08 -13.16,6.04 -13.08,13.35l0.01 181.8 -142.28 0 0 -277.38 451.26 0 0 277.38zm41.29 -354.93l0 38.86c0,6.53 -5.13,11.9 -11.7,12.08l-510.54 0.01c-6.52,-0.18 -11.59,-5.61 -11.59,-12.09l0 -38.86 533.83 0zm-385.76 164.78l-78.81 0c-7.35,0 -13.31,5.96 -13.31,13.31l0 73.81c0,7.35 5.97,13.3 13.31,13.3l78.81 0c7.35,0 13.3,-5.95 13.3,-13.3l0 -73.81c0,-7.35 -5.95,-13.31 -13.3,-13.31zm-13.31 73.81l-52.2 0 0 -47.19 52.2 0 0 47.19zm328.56 -73.81l-78.81 0c-7.36,0 -13.31,5.96 -13.31,13.31l0 73.81c0,7.35 5.96,13.3 13.31,13.3l78.81 0c7.35,0 13.3,-5.95 13.3,-13.3l0 -73.81c0,-7.35 -5.95,-13.31 -13.3,-13.31zm-13.3 73.81l-52.21 0 0 -47.19 52.21 0 0 47.19z"
              />
            </svg>
            <span class="nav__link">پروفایل</span>
          </router-link>
          <router-link class="nav__item" :to="{ name: 'TransactionList' }">
            <svg viewBox="0 0 700 512" class="nav__itemLogo">
              <path
                d="M272.1 201.32l0 -0.04 0.27 -0.02c6.82,-0.61 12.05,-6.35 12.05,-13.2 0,-6.85 -5.23,-12.59 -12.05,-13.2l-0.27 -0.03 0 -0.03 -26.01 0 0 -27.94 -0.03 0 -0.03 -0.26c-0.61,-6.82 -6.35,-12.05 -13.2,-12.05 -6.85,0 -12.59,5.23 -13.2,12.05l-0.03 0.26 -0.03 0 0 27.94 -2.77 0c-27.28,0 -49.6,22.32 -49.6,49.6 0,27.27 22.32,49.59 49.6,49.59l32.06 0c12.7,0 23.08,10.39 23.08,23.08 0,12.7 -10.38,23.08 -23.08,23.08l-55.3 0 0 0.04 -0.26 0.02c-6.82,0.62 -12.05,6.35 -12.05,13.2 0,6.85 5.23,12.59 12.05,13.21l0.26 0.02 0 0.03 26.01 0 0 27.94 0.03 0 0.03 0.26c0.61,6.82 6.35,12.05 13.2,12.05 6.85,0 12.59,-5.23 13.2,-12.05l0.03 -0.26 0.03 0 0 -27.94 2.77 0c27.28,0 49.6,-22.32 49.6,-49.6 0,-27.27 -22.32,-49.59 -49.6,-49.59l-32.06 0c-12.7,0 -23.08,-10.39 -23.08,-23.08 0,-12.7 10.38,-23.08 23.08,-23.08l55.3 0zm-92.37 310.68l0 -26.52 -87.39 0c-36.21,0 -65.83,-29.62 -65.83,-65.82l0 -313c0,-36.21 29.62,-65.83 65.83,-65.83l87.39 0 0 -26.51 -87.39 0c-50.79,0 -92.34,41.55 -92.34,92.34l0 313c0,50.79 41.55,92.34 92.34,92.34l87.39 0zm106.21 -497.68l0 26.51 321.72 0c36.2,0 65.83,29.62 65.83,65.83l0 313c0,36.2 -29.63,65.82 -65.83,65.82l-321.72 0 0 26.52 321.72 0c50.79,0 92.34,-41.55 92.34,-92.34l0 -313c0,-50.79 -41.55,-92.34 -92.34,-92.34l-321.72 0z"
              />
            </svg>
            <span class="nav__link">تراکنش ها</span>
          </router-link>
          <router-link :to="{ name: 'TicketSupport' }" class="nav__item">
            <svg
              style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
              viewBox="0 0 700 512"
              class="nav__itemLogo"
            >
              <path
                d="M94 512l512 0 0 -53.42c0,-23.16 -14.78,-43.56 -36.78,-50.77l-136.24 -44.66 0 -48.52 0.33 -0.48c9.77,-14.44 15.92,-31.02 18.11,-48.31l0.21 -1.68 26.04 0c20.21,0 36.65,-16.44 36.65,-36.65l0 -41.31c0,-7.39 -2.21,-14.54 -6.38,-20.64l-0.34 -0.49 0 -7.47c0,-86.9 -70.7,-157.6 -157.6,-157.6 -86.9,0 -157.6,70.7 -157.6,157.6l0 7.47 -0.34 0.49c-4.17,6.1 -6.38,13.25 -6.38,20.64l0 41.31c0,20.21 16.44,36.65 36.65,36.65l26.04 0 0.21 1.68c2.22,17.52 8.51,34.31 18.51,48.89l0.34 0.49 0 47.8 -136.65 44.79c-22,7.21 -36.78,27.61 -36.78,50.77l0 53.42 0 0zm202.78 -168.27c15.93,10.29 34.23,15.81 53.22,15.81 19.15,0 37.6,-5.61 53.62,-16.07l2.96 -1.93 0 25.26 -0.66 0.58c-14.11,12.15 -36.68,26.69 -55.92,26.69 -19.18,0 -41.53,-14.47 -55.52,-26.65l-0.65 -0.57 0 -25.02 2.95 1.9 0 0zm86.76 -213.28l-26.47 0c-1.01,25.97 -22.45,46.78 -48.66,46.78l-34.34 0.01 0 -16.48c0,-41.87 34.06,-75.93 75.93,-75.93 41.87,0 75.93,34.06 75.93,75.93l0 16.11 -2.25 -0.4c-22.54,-4 -39.24,-23.28 -40.14,-46.02zm-14.28 140.23l0 26.39 43.79 0 -2.07 3c-13.95,20.21 -36.2,33.07 -60.98,33.07 -44.03,0 -75.93,-39.07 -75.93,-81.67l0 -47.84 34.34 0c23.89,0 46.17,-11.32 60.36,-30.46l1.54 -2.08 1.54 2.08c12.5,16.86 31.45,27.82 52.36,30.04l1.72 0.18 0 48.08c0,5.94 -0.62,11.86 -1.82,17.68l-0.31 1.53 -54.54 0 0 0zm118.66 -43.17c0,5.66 -4.6,10.25 -10.25,10.25l-25.35 0 0 -61.82 25.35 0c5.65,0 10.25,4.61 10.25,10.26l0 41.31zm-137.92 -201.11c68.42,0 125.62,52.93 130.82,121.12l0.16 2.13 -2.13 -0.07c-0.39,-0.01 -0.79,-0.03 -1.18,-0.03l-25.94 0 -0.22 -1.68c-6.43,-50.98 -50.08,-89.44 -101.51,-89.44 -51.43,0 -95.08,38.46 -101.52,89.44l-0.21 1.68 -25.94 0c-0.39,0 -0.79,0.02 -1.19,0.03l-2.13 0.07 0.17 -2.13c5.2,-68.19 62.4,-121.12 130.82,-121.12l0 0zm-137.92 201.11l0 -41.31c0,-5.65 4.6,-10.26 10.25,-10.26l25.35 0 0 61.82 -25.35 0c-5.65,0 -10.25,-4.6 -10.25,-10.25zm289.86 226.86l-26.4 0 0 31.23 -251.09 0 0 -31.23 -26.39 0 0 31.23 -77.66 0 0 -27.02c0,-11.71 7.48,-22.04 18.6,-25.69l138.42 -45.37 0.81 0.7c19.18,16.35 45.93,32.24 71.77,32.24 25.84,0 52.75,-15.9 72.02,-32.17l0.82 -0.68 138.15 45.28c11.13,3.65 18.61,13.98 18.61,25.69l0 27.02 -77.66 0 0 -31.23 0 0z"
              />
            </svg>

            <span class="nav__link">پشتیبانی</span>
          </router-link>
          <router-link class="nav__item" :to="{ name: 'ProfileRules' }">
            <svg viewBox="0 0 700 512" class="nav__itemLogo">
              <path
                d="M415.07 283.49l0 2.65c0,40.65 33.07,73.72 73.71,73.72l30.22 0c40.64,0 73.71,-33.07 73.71,-73.72l0 -2.65 -68.89 -165.34 19.34 0 6.06 0c7.3,0 13.28,-5.97 13.28,-13.28l0 0c0,-7.31 -5.98,-13.29 -13.28,-13.29l-59.22 0 -0.09 0 -111.76 0 -0.43 -1.21c-4.38,-12.34 -14.17,-22.14 -26.51,-26.51l-1.21 -0.43 0 -42.66 0 0 0 -7.55c0,-7.31 -5.98,-13.29 -13.29,-13.29l0 0c-7.31,0 -13.28,5.98 -13.28,13.29l0 7.55 -0.01 0 0 42.66 -1.21 0.43c-12.34,4.37 -22.13,14.17 -26.51,26.51l-0.43 1.21 -111.76 0 -0.09 0 -59.22 0c-7.3,0 -13.28,5.98 -13.28,13.29l0 0c0,7.31 5.98,13.28 13.28,13.28l6.06 0 19.34 0 -68.89 165.34 0 2.65c0,40.65 33.07,73.72 73.71,73.72l30.22 0c40.64,0 73.71,-33.07 73.71,-73.72l0 -2.65 -68.88 -165.34 105.8 0 0.43 1.21c4.38,12.34 14.17,22.14 26.51,26.51l1.21 0.43 0 219.39 -1.45 0.3c-29.3,5.97 -52.26,29.35 -57.72,58.74l-0.23 1.23 -1.22 0.23c-34.8,6.46 -60.23,37 -60.23,72.45l0 13.29 268.28 0 0 -13.29c0,-35.45 -25.43,-65.99 -60.23,-72.45l-1.22 -0.23 -0.23 -1.23c-5.46,-29.39 -28.43,-52.78 -57.72,-58.75l-1.45 -0.29 0 -219.39 1.21 -0.43c12.34,-4.37 22.13,-14.17 26.51,-26.51l0.43 -1.21 105.8 0 -68.88 165.34 0 0zm-245.54 -144.07l55.6 133.43 -111.2 0.01 55.6 -133.44 0 0zm15.11 193.86l-30.22 0c-19.98,0 -37.78,-12.66 -44.43,-31.43l-0.86 -2.43 120.8 0 -0.86 2.43c-6.65,18.77 -24.45,31.43 -44.43,31.43l0 0zm319.25 -193.86l55.6 133.43 -111.2 0.01 55.6 -133.44 0 0zm15.11 193.86l-30.22 0c-19.98,0 -37.78,-12.66 -44.43,-31.43l-0.86 -2.43 120.8 0 -0.86 2.43c-6.65,18.77 -24.45,31.43 -44.43,31.43l0 0zm-76.56 152.07l-211.46 0 0.86 -2.42c6.65,-18.77 24.47,-31.43 44.44,-31.43l120.86 0c19.97,0 37.78,12.66 44.44,31.43l0.86 2.42 0 0zm-60.44 -60.42l-90.58 0 0.86 -2.43c6.65,-18.77 24.46,-31.42 44.43,-31.42 19.98,0 37.78,12.65 44.43,31.42l0.86 2.43 0 0zm-45.29 -303.14c-9.33,0 -16.92,-7.59 -16.92,-16.92 0,-9.34 7.59,-16.93 16.92,-16.93 9.33,0 16.92,7.59 16.92,16.93 0,9.33 -7.59,16.92 -16.92,16.92z"
              />
            </svg>
            <a class="nav__link">قوانین</a>
          </router-link>
          <a href="tel:02191310333" class="nav__item">
            <svg
              viewBox="0 0 512 512"
              class="nav__itemLogo"
              style="width: 34px; height: 34px;margin-bottom: 12px;"
            >
              <path
                d="m416.303 242.244-72.456-72.457v-124.787c0-24.813-20.187-45-45-45h-196c-24.813 0-45 20.187-45 45v422c0 24.813 20.187 45 45 45h306c7.146 0 13.299-5.04 14.706-12.046l27.953-139.147c8.732-43.466-4.428-87.788-35.203-118.563zm-313.456-212.244h196c8.271 0 15 6.729 15 15v193.479c-18.398-18.146-47.955-18.046-66.228.226-18.311 18.281-18.399 47.958-.122 66.359l57.456 59.733c-12.456 9.296-28.592 25.521-40.18 52.203h-176.926v-372c0-8.271 6.728-15 15-15zm-15 437v-20h167.229c-2.378 10.518-4.06 22.148-4.801 35h-147.428c-8.272 0-15-6.729-15-15zm334.247-112.102-25.533 127.102c-24.121 0-91.451 0-116.216 0 2.163-31.861 11.334-58.562 26.846-77.835 12.86-15.979 25.954-21.708 26.997-22.146 9.815-3.513 13.323-16.253 5.47-24.417-70.924-73.736-70.706-73.512-70.834-73.638-6.588-6.588-6.692-17.355 0-24.037 6.613-6.612 17.362-6.63 23.997-.049 31.711 32.436 16.291 16.871 71.785 72.364 5.857 5.858 15.355 5.859 21.213 0 5.858-5.858 5.858-15.355 0-21.213l-41.972-41.971v-56.844l51.243 51.243c23.658 23.658 33.754 57.842 27.004 91.441z"
              />
            </svg>
            <span class="nav__link">تماس با ویپون</span>
          </a>
          <router-link class="nav__item" :to="{ name: 'ProfileAboutUs' }">
            <svg viewBox="0 0 700 512" class="nav__itemLogo">
              <path
                d="M350 283.09l179.22 -181.84c-8.15,-9.58 -17.05,-18.51 -26.61,-26.68l-152.61 154.83 -152.61 -154.83c-9.56,8.17 -18.46,17.1 -26.61,26.68l179.22 181.84zm-229.31 -83.37c-3.71,15.44 -5.86,31.23 -6.45,47.14l235.76 239.2 235.76 -239.2c-0.59,-15.91 -2.74,-31.7 -6.45,-47.14l-229.31 232.66 -229.31 -232.66zm229.31 -119.61l54.66 -55.46c-35.59,-8.31 -73.73,-8.31 -109.31,0l54.65 55.46z"
              />
            </svg>

            <a class="nav__link">درباره ویپون</a>
          </router-link>
        </ul>
        <div class="nav__btn btn--package btn--logout" @click="logout">
          <span>خروج</span>
          <svg viewBox="0 0 700 512" class="nav__itemLogo">
            <path
              d="M418.67 33.69c-9.04,-2.64 -18.53,2.55 -21.17,11.59 -2.66,9.04 2.54,18.53 11.58,21.17 86.77,25.4 150.84,105.67 150.84,201.5 0,115.75 -94.17,209.91 -209.92,209.91 -115.75,0 -209.92,-94.16 -209.92,-209.91 0,-95.63 63.88,-176.04 150.84,-201.5 9.04,-2.64 14.22,-12.13 11.58,-21.17 -2.65,-9.04 -12.13,-14.23 -21.17,-11.59 -100.05,29.29 -175.38,121.98 -175.38,234.26 0,134.89 109.15,244.05 244.05,244.05 134.89,0 244.05,-109.15 244.05,-244.05 0,-111.55 -74.61,-204.76 -175.38,-234.26zm-68.67 -33.69c-9.43,0 -17.07,7.64 -17.07,17.07l0 161.05c0,9.43 7.64,17.07 17.07,17.07 9.43,0 17.07,-7.64 17.07,-17.07l0 -161.05c0,-9.43 -7.64,-17.07 -17.07,-17.07z"
            />
          </svg>
        </div>
        <p class="nav__copy">
          VIPON &copy; 2021
        </p>
      </div>
    </div>
    <div class="nav__close" tabindex="-1" v-if="show" @click="show = !show" />
  </div>
</template>

<script>
import { computed, ref, watchEffect, onBeforeUnmount } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
  name: 'Navbar',
  props: {
    navType: {
      type: String,
      default: 'normal'
    },
    msg: String,
    backRoute: String
  },
  setup(props) {
    // Opening and closing navbar collapse
    const show = ref(false)
    const toggleShow = () => {
      show.value = !show.value
    }

    // Logout user
    const store = useStore()
    const logout = () => {
      store.dispatch('logoutUser')
    }

    // Back button
    const router = useRouter()
    const goBack = () => {
      // #TODO add savedPosition with beforeeach in vue router
      if (props.backRoute) router.push(props.backRoute)
      else store.dispatch('goBack')
    }

    const expDay = computed(() => store.state.accountExpiration)
    const credit = computed(() => store.state.homeData?.wallet)
    // Handle Modal
    const applyModalEffect = () => {
      const body = document.querySelector('body')
      body.style.top = `-${window.scrollY}px`
      body.style.position = 'fixed'
    }
    const removeModalEffect = () => {
      const body = document.querySelector('body')
      const scrollY = document.body.style.top
      body.style.position = ''
      body.style.top = ''
      window.scrollTo(0, parseInt(scrollY || '0') * -1)
    }
    watchEffect(() => {
      if (show.value) {
        applyModalEffect()
      } else {
        removeModalEffect()
      }
    })

    onBeforeUnmount(() => {
      if (show.value) {
        removeModalEffect()
      }
    })

    // ---------- //
    return { show, toggleShow, logout, goBack, expDay, credit }
  }
}
</script>

<style scoped lang="scss">
$nav-height: 60px;

.nav-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.nav {
  position: fixed;
  z-index: 101;
  right: 0;
  left: 0;
  border-radius: 0;
  top: 0;
  padding: 0;
  margin: 0;
  width: 100%;
  height: $nav-height;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  display: grid;
  grid-template-rows: $nav-height;
}
.nav--normal {
  grid-template-columns: 2% [toggle] 30px [msg] auto [back] 30px 2%;
}
.nav--home {
  grid-template-columns: 2% [toggle] 30px [logo] auto 2%;
}
.nav__msg {
  grid-column-start: msg;
  line-height: 60px;
  text-align: center;
  color: #fff;
  margin: 0;
  font-size: 17px;
}
.nav__btn {
  display: block;
  outline: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
}
.btn--main {
  grid-column-start: toggle;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn--back {
  grid-column-start: back;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  svg {
    fill: #ddd;
    width: 30px;
    height: 30px;
  }
}
.btn--package {
  z-index: -2;
  text-align: center;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 12px);
  height: 60px;
  border-radius: 10px;
  font-size: 13px;

  svg {
    position: relative;
    bottom: 1px;
    fill: #c69d4e;
    width: 30px;
    height: 30px;
    margin: 0;
  }
}
.btn--logout {
  background-color: #000;
  color: #fff;
  span {
    margin-right: 5px;
  }
  padding: 10px 0;
  height: auto;
}
.nav__icon {
  fill: #a8a8a8;
  width: 30px;
  height: 30px;
  margin-bottom: 8px;
}

.collapse {
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 102;
  min-height: 100vh;
  background: linear-gradient(to bottom, #fff 150px, #eee 250px);
  border-radius: 40px 0 0 0;
  top: 0px;
  right: -100%;
  width: 70%;
  transition: all 0.3s ease;
}
.collapse--show {
  right: 0;
}
.collapse__inside {
  direction: ltr;
  height: 100vh;
  z-index: 103;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow-y: auto;
  padding-top: 15px;
}
.collapse__logo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  img {
    width: 110px;
    max-height: 200px;
  }
}
.collapse__items {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  gap: 6px;
  padding: 0 6px;
  margin: 8px 0;
}
.nav__logo {
  padding: 0;
  margin: 0;
  justify-self: flex-end;
  align-self: center;
  grid-column-start: logo;
  width: 110px;
}

.nav__close {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  z-index: 101;
  opacity: 0.75;
}

// .nav__hr {
//   width: 96%;
//   height: 1px;
//   background-color: rgba(#000, 0.1);
// }
.nav__item {
  background-color: #fff;
  height: 100px;
  display: flex;
  border-radius: 15px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.nav__itemLogo {
  fill: #c69d4e;
  width: 44px;
  height: 44px;
  margin-bottom: 5px;
}
.nav__link {
  cursor: pointer;
  padding: 0;
  display: block;
  width: 100%;
  color: black;
  text-align: center;
  font-size: 13px;
}
.remain {
  position: relative;
  z-index: auto;
  height: 130px;
  width: 130px;
  border-radius: 100%;
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 20px 1px rgba(#000, 0.2);
  background-color: #fff;
  overflow: visible;
}
.remain__animate {
  width: 100%;
  z-index: -1;
  height: 100%;
  background-color: #c69d4e;
  position: absolute;
  border-radius: 100%;
  animation: scaleBg 1.3s infinite;
}
.remain__day {
  z-index: 2;
  margin: 3px 0;
  padding-bottom: 0;
  color: #c69d4e;
  font-size: 40px;
  font-weight: bold;
  animation: blinking 1.3s infinite;
}

.remian__text {
  z-index: 2;
  margin-top: 0;
}
.remain__left {
  z-index: 2;
  color: #111;
  margin-top: -8px;
  font-size: 14px;
}
.nav__copy {
  font-size: 12px;
  direction: ltr;
  width: 100%;
  padding: 0 5px;
  text-align: center;
  margin-top: 15px;
}
.money {
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 85px;
  width: 65%;
  cursor: pointer;
  .money__title {
    font-size: 16px;
    color: #a7a7a7;
  }
  .money__add {
    fill: #aaa;
    width: 24px;
    height: 24px;
    margin: 1px 5px 0 0;
  }
  .money__row {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .money__price {
    color: #1a1a1a;
    height: 45px;
    line-height: 45px;
    font-size: 24px;
    font-weight: bold;
    margin: 4px 0 0;
    &::after {
      content: 'R';
      color: #a7a7a7;
      font-size: 14px;
      top: -6px;
      left: 3px;
      position: relative;
    }
  }
}
@keyframes scaleBg {
  0% {
    transform: scale(1);
    opacity: 0.3;
  }
  100% {
    opacity: 0;
    transform: scale(1.5);
  }
}
@keyframes blinking {
  0% {
    opacity: 1;
    color: #c69d4e;
  }
  100% {
    opacity: 0.2;
    color: #777;
  }
}
</style>
